// @import dependencies
import React, {Component} from 'react'
import moment from 'moment'
// @end

// @import components
import {NewsitemScreenLayout} from 'app_components/screens/landing/newsitem'
// @end

// @INFO Import types
import { IPost } from 'app_types/campus/postTypes'
// @end

// @import services
import NewsService from 'app_services/campus/news/newsService'
// @end

// @ADD Component types
interface INewsitemScreenProps {
  newsData: any
  match?: any
}
interface INewsitemScreenState {
  post: IPost | null
  posts: Array<any>
  loading_post: boolean
  loading_posts: boolean
}

class NewsitemScreen extends Component<INewsitemScreenProps, INewsitemScreenState> {

  private newsService: NewsService;

  constructor(props: INewsitemScreenProps){
    super(props)
    this.state = {
      post: null,
      posts: [],
      loading_post: true,
      loading_posts: true
    }
    this.newsService = new NewsService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    if (this.props?.match?.params?.slug) {
      await this.getNews(this.props?.match?.params?.slug)
      await this.getImportants()
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = async (before: any, after: any) => {
    if (this.props?.match?.params?.slug !== before?.match?.params.slug) {
      await this.getNews(this.props?.match?.params?.slug)
      await this.getImportants()
    }
  }

  // @Add custom methods

  getNews = async (slug: string) => {
    this.setState({ loading_post: true })

    let post: any = null

    const newsResponse = await this.newsService.fetchNew(slug)

    if (newsResponse && newsResponse.post) {
      post = newsResponse.post
    }

    this.setState({
      post,
      loading_post: false
    })
  }

  getImportants = async () => {
    this.setState({ loading_posts: true })

    const httpParams: any = {
      pageNumber: 1,
      nPerPage: 3,
      isActive: true,
      postType: ['news'],
      postDate: {
        date: 'today',
        direction: 'lte'
      },
      locations: ['guest'],
      sort: {
        field: 'postDate',
        direction: -1
      },
      onlyImportant: true,
      exclude: [
        this.state.post?._id
      ]
    }

    let news: Array<any> = []

    const newsResponse = await this.newsService.fetchNews(httpParams)

    if (newsResponse && newsResponse.posts) {
      news = newsResponse.posts.reduce((accum: any, element: any) => {
        let postDate = moment.utc(element?.postDate)
        let item = {
          key: element?._id,
          slug: element?.slug,
          cover: element?.coverUrl,
          postDate: postDate.format('DD/MM/YYYY'),
          title: element?.title,
          subtitle: element?.subtitle
        }

        accum.push(item)

        return accum
      }, [])
    }

    this.setState({
      posts: news,
      loading_posts: false
    })
  }

  render() {
    return(
      <NewsitemScreenLayout
        post={this.state.post}
        posts={this.state.posts}
        loading_post={this.state.loading_post}
        loading_posts={this.state.loading_posts}
      />
    )
  }
}

export default NewsitemScreen
